import React, { useEffect, useMemo } from "react";
import { XApp } from "../models/x-app";

export const AppContext = React.createContext<XApp | null>(null);

export type AppProviderProps = {
  accessToken: string;
  children: React.ReactNode;
  onFragmentUpdate: (args: { typename: string; id: string | number }) => void;
};

export function AppProvider({
  accessToken,
  children,
  onFragmentUpdate,
}: AppProviderProps) {
  const xappInstance = useMemo(
    () => new XApp(accessToken, onFragmentUpdate),
    [accessToken, onFragmentUpdate]
  );

  useEffect(() => {
    return () => {
      xappInstance.destroy();
    };
  }, [xappInstance]);

  return (
    <AppContext.Provider value={xappInstance}>{children}</AppContext.Provider>
  );
}
